export default "__VITE_ASSET__w9TP8jSx__"